<template>
  <el-form-item
    :prop="propVal"
    v-bind="attrs"
    :rules="rules"
    >
    <span
      v-if="hasLabel"
      slot="label"
      >
      {{ label }}
      <el-popover
        v-if="hasDesc"
        placement="top"
        :title="descTitleVal"
        trigger="hover"
        transition="none"
        :open-delay="100"
        :tabindex="-1"
        >
        <div
          class="form-item-readme-content"
          v-html="descContent"
          >
        </div>
        <el-link
          slot="reference"
          class="form-item-readme-link"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >
        </el-link>
      </el-popover>
    </span>
    <el-badge
      class="form-item-badge"
      type="info"
      :hidden="!$attrs.badgeValue"
      :value="$attrs.badgeValue"
      >
      <slot></slot>
    </el-badge>
  </el-form-item>
</template>

<script>

export default {
  name: 'form-item',
  props: {
    name: {
      type: String,
      required: true
    },
    prop: {
      type: String
    },
    isBindAttrs: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array
    },
    hasLabel: {
      type: Boolean,
      default: true
    },
    label: {
      type: String
    },
    labelClass: {
      type: String,
      default: ''
    },
    hasDesc: {
      type: Boolean,
      default: false
    },
    descTitle: {
      type: String,
      default: ''
    },
    descContent: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    propVal () {
      return this.prop || this.name
    },
    descTitleVal () {
      return this.descTitle || this.label
    },
    attrs () {
      return this.isBindAttrs ? this.$attrs : null
    }
  },
  methods: {
  },
  watch: {
  }
}
</script>
